import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { RoleManagementService } from '@services/role.management.service';
import { TestService } from '@services/test.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserService } from '@services/user.service';
import { TestsBasicDetailsComponent } from '../tests-basic-details/tests-basic-details.component';
import { CollectionService } from '@services/collection.service';
import { WebErrorService } from '@services/webError.service';
import { videoAssetGroups } from '@configs/videoTitles';
export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

@Component({
  selector: 'app-tests-details',
  templateUrl: './tests-details.component.html',
  styleUrls: ['./tests-details.component.scss']
})
export class TestsDetailsComponent {
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
  @ViewChild('table') table: MatTable<any>;
  testUUID: any = '';

  testServiceSubscription: Subscription;
  routeSubscription: Subscription;
  displayedColumns: string[] = ['itemBankName', 'itemDescription'];
  dataSource: any;
  testuuId1: any;
  questions: any;
  itemdetails: any;
  numberOfQuestions = 0;
  itemBasicDetails = {
    testTitle: "",
    testDescription: "",
    collectionId: "",
    testuuid: "",
    statusName: ""
  };
  testBankId: any;
  action = '';
  tab: any;
  tab1: boolean = false;
  isReadMore: boolean = true;
  display: boolean = false;
  isPublished: boolean;
  passTestDetailData: any;
  testItems: any;
  testTitle: any;
  testStatus: any;
  testDescription: any;
  tabData: any;
  dataOfTestDetails: any;
  selectedIndex: any;
  isTestItemCount: any;
  data: any;
  testDetailSubscription: Subscription;
  perOfTestCredits: number;
  totalTestCredits: number;
  creditsAvailable: number;
  creditsConsumed: number;
  globalcollectionuuid: any;
  negativeTestCreditsAvailable: number = 0;
  testStatusList: any;
  selectedTabIndex = 0;
  itemStatusId: any;
  isHidden = false;
  videoLinks: any;
  videoAssetGroups = videoAssetGroups;
  hoverVideoApiCall: boolean = false;
  constructor(private testService: TestService, private router: Router,
    private activatedRoute: ActivatedRoute, private dialog: MatDialog,
    public CollectionService: CollectionService,
    public roleSer: RoleManagementService, private userService: UserService,
    private webErrorService: WebErrorService,) {
    this.testService.getTestStatusListt.subscribe(d => {this.testStatusList = d;});
    this.testService.isTestItemCount.subscribe(istestcount => {
      this.isTestItemCount = istestcount;
    });
    // this.testUUID = localStorage.getItem('TestId');
    // if (localStorage.getItem('TestId')) {
    //   this.testService.getItemByTestId(this.testUUID)?.subscribe(
    //     (data) => {
    //       this.tabData = data;
    //     });
    // }

    this.globalcollectionuuid = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));
    this.testService.getStyleGroups(JSON.parse(sessionStorage.defaultcollectionid)).subscribe(data => {
      this.testService.styleGroup.next(data.data);
    });
    // this.testService.loadItemGroups.subscribe(data => {
    //   if (data) {
    //     this.getTestData();
    //   }
    // });
    // this.routeSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd))
    //   .subscribe(url => {this.getTestData()});
    this.getTestData()
    this.getCreditSummaryData();
    this.onTrainingIcon(videoAssetGroups.ManageTestDetails);
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
      if(args.target.className != 'trainingIcon') {
        this.isHidden = false;
      }
    }
  }

  onTrainingIcon(groupName) {
    this.testService.videoTutorial(groupName).subscribe(video => {
      this.videoLinks = video.data;
    });
  }

  open_in_new_window(features, link) {
    var new_window;
    if(features !== undefined && features !== '') {
      new_window = window.open('', '_blank', features);
    }
    else {
      new_window = window.open('', '_blank');
    }

    let video = '<video controls controlsList="nodownload" style="width: 100%; height: 100vh;"><source src="' + link + '" type="video/mp4" /></video>'

    if(link !== null && link !== '') {
      new_window.document.write('<!doctype html><html><head><title>Video Player</title><meta charset="UTF-8" /></head><body style="padding: 0; margin: 0;" oncontextmenu="return false">' + video + '</body></html>');
    }
  }

  getCreditSummaryData() {
    this.userService.getcreditsummary().subscribe(res => {
      if (res) {
        this.totalTestCredits = res.totalTestCredits;
        this.creditsAvailable = res.creditsAvailable;
        this.creditsConsumed = res.creditsConsumed;
        this.negativeTestCreditsAvailable = res.negativeTestCreditsAvailable;
        this.perOfTestCredits = (res.totalTestCredits / 100) * 20;
      }
    })
  }

  getTestData() {
    this.testService.getUpdatedTest.subscribe(resData => {
      this.testTitle = resData?.data?.testTitle;
      this.testDescription = resData?.data?.testDescription;
    });
    this.testUUID = this.activatedRoute.snapshot.paramMap.get('id');
    if (!this.testUUID) {
      this.action = 'createTest';
    } else {
      this.action = 'editTest';
      sessionStorage.setItem('testuuid', this.testUUID);

      this.testService.getTestStatusList()?.subscribe(data => {
        this.testStatusList = data?.statuslist.slice(0, 2);
        this.testService.testStatusList.next(this.testStatusList);

        this.testDetailSubscription = this.testService.getTestDetails(this.testUUID).subscribe(
          resData => {
            // sessionStorage.setItem('testScoringTypeId', resData?.data?.scoringTypeId);
                      this.dataOfTestDetails = resData;
            this.testuuId1 = resData?.data?.testUUID;
            this.testTitle = resData?.data?.testTitle;
            this.testDescription = resData?.data?.testDescription;
            this.testBankId = resData?.data?.testId;
            this.passTestDetailData = resData?.data;
            this.numberOfQuestions = resData?.data?.questions?.length;
            this.questions = new MatTableDataSource(resData?.data?.questions);
            this.itemBasicDetails['testTitle'] = resData?.data?.testTitle;
            this.itemBasicDetails.testDescription = resData?.data?.testDescription;
            this.itemBasicDetails.testuuid = this.testUUID;
            // this.itemBasicDetails.statusName = resData?.data?.statusId;
            this.itemBasicDetails.statusName = this.testStatusList.filter(d => d.itemStatusId === resData?.data?.statusId)[0].itemStatus;
            this.itemStatusId = resData?.data?.statusId;
            this.testService.testDetails.next(resData?.data);
            this.testService.ItemCategory.next(resData.data.lstItemCategoryMaster);
            if (this.itemStatusId == this.testStatusList[0].itemStatusId) {
              this.isPublished = true;
            } else {
              this.isPublished = false;
            }
          }, () => { }, () => { this.testDetailSubscription.unsubscribe() }
        );
      },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
    }

    this.testService.updateTestStatus.subscribe((resData: any) => {
      if (resData == true) {
        this.itemBasicDetails.statusName = this.testStatusList[0].itemStatus;
        this.dataOfTestDetails.data.statusName = this.testStatusList[0].itemStatus;
        this.dataOfTestDetails.data.statusId = this.testStatusList[0].itemStatusId;
      }
    });

    if (this.testUUID) {
      this.testServiceSubscription = this.testService.getItemByTestId(this.testUUID)?.subscribe(
        (data) => {
          this.testItems = data?.data;
          if (this.testItems?.length == 0) {
            this.isTestItemCount = "0";
          } else {
            this.testItems = new MatTableDataSource(this.testItems);
            this.isTestItemCount = this.testItems?.filteredData?.length;
          }
        },
        (error) => { },
        () => { this.testServiceSubscription.unsubscribe(); }) || undefined;
    }
  }

  callTestDetails(event:any) {
    // console.log('child to parent call',event)
    if(event === true){
      this.getTestData();
    }
  }

  navigateToSelectQuestionsType() {
    this.router.navigate(["./selectquestiontype"], { relativeTo: this.activatedRoute });
  }

  navigateToItemLanding() {
    if (this.action === 'createTest') {
      this.router.navigate(["../test"], { relativeTo: this.activatedRoute });
    } else if (this.action === 'editTest') {
      this.router.navigate(["../../test"], { relativeTo: this.activatedRoute });
    } else {
      this.router.navigate(["../../test"], { relativeTo: this.activatedRoute });
    }
  }

  navigatetoTest() {
    this.router.navigate(["../../test"], { relativeTo: this.activatedRoute });
  }

  onChange(event: MatTabChangeEvent) {
    this.selectedTabIndex = event.index;
    this.tab1 = true;
    this.tab = event.tab.textLabel;
    if (this.selectedTabIndex == 2) {
      this.onTrainingIcon(videoAssetGroups.TestSchedule);
    } else {
      this.onTrainingIcon(videoAssetGroups.ManageTestDetails);
    }
    if (this.tab == 'Schedule' && this.isPublished) {
      this.display = true;
    } else {
      this.display = false;
    }
  }

  ngOnDestroy() {
    if (this.testDetailSubscription) {
      this.testDetailSubscription.unsubscribe();
    }
    if (this.testServiceSubscription) {
      this.testServiceSubscription.unsubscribe();
    }
  }

  openEditTestDialog() {
    if(this.roleSer.accessData && this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed){
      this.dialog.open(TestsBasicDetailsComponent, {
        minWidth: '650px', data: { testUUID: this.testUUID, testData: this.dataOfTestDetails }
      });
    };
  }

}

